import React, { useState } from 'react';
import {
  FileCsv,
  FileDoc,
  FileHtml,
  FileJpg,
  FilePdf,
  FilePng,
  FileText,
  FileTxt,
  FileImage,
} from '@phosphor-icons/react';
import type { Icon } from '@phosphor-icons/react';
import type { GeneratedFile } from '../../../../types/generatedFile';
import { Item } from './Item';
import { ActionMenu } from './ActionMenu';

interface GeneratedFileItemProps {
  file: GeneratedFile;
  onPreview: (file: GeneratedFile) => void;
  onRename: (file: GeneratedFile) => void;
  onDelete: (file: GeneratedFile) => void;
  isNested?: boolean;
}

export const GeneratedFileItem: React.FC<GeneratedFileItemProps> = ({
  file,
  onPreview,
  onRename,
  onDelete,
  isNested = true,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const label = file.name || file.provider;
  const fileTypeIcons: Record<string, Icon> = {
    pdf: FilePdf,
    docx: FileDoc,
    html: FileHtml,
    txt: FileTxt,
    csv: FileCsv,
    jpg: FileJpg,
    jpeg: FileJpg,
    png: FilePng,
    webp: FileImage,
  };
  const IconComponent = fileTypeIcons[file.fileType] ?? FileText;

  return (
    <>
      <Item
        icon={<IconComponent size={16} />}
        label={label}
        isNested={isNested}
        onClick={() => onPreview(file)}
        onMenuClick={anchor => setAnchorEl(anchor)}
      />
      <ActionMenu
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onRename={() => {
          setAnchorEl(null);
          onRename(file);
        }}
        onDelete={() => {
          setAnchorEl(null);
          onDelete(file);
        }}
      />
    </>
  );
};
